import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import Routes from './components/Routes'
import {Route} from 'react-router'
import {CorBusiness} from "cor-business";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <CorBusiness config={{
        apiBaseUrl: import.meta.env.VITE_API_AUTH_BASE_URL,
        afterAuthRedirectUrl: "/soon"
    }}>
        <Route path={'*'} element={<Routes />}/>
    </CorBusiness>
);
